import React, { useState } from 'react';

/* Profile → Stack Settings tab: 8 editable stake-value inputs (2 per row) + Save.
   Each input-group prefixes the value with its label (input-group-text). */
const DEFAULTS = [50, 100, 200, 500, 1000, 1500, 2000, 2500];

export default function StakeSettings() {
  const [vals, setVals] = useState(DEFAULTS.map(String));
  const set = (i, v) => setVals((prev) => prev.map((x, j) => (j === i ? v : x)));
  return (
    <div className="app-stake-settings">
      <form className="stack-setting" noValidate onSubmit={(e) => e.preventDefault()}>
        <div className="row my-2">
          {vals.map((v, i) => (
            <div className="col-6" key={i}>
              <div className="input-group">
                <span id="basic-addon1" className="input-group-text"><b><small>{DEFAULTS[i]}</small></b></span>
                <input
                  type="number"
                  className="form-control"
                  id={`stackVal${i}`}
                  value={v}
                  onChange={(e) => set(i, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
        <button type="button" className="btn btn-theemes mb-2">Save</button>
      </form>
    </div>
  );
}
